import _extends from "@babel/runtime-corejs2/helpers/extends";
import "core-js/modules/es6.function.name";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

var _dec, _class, _class2, _temp;

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { styled, StyleSheet } from '@rexlabs/styling';
import { getBase64, isFileImage } from './';
import _ from 'lodash';
var File = (_dec = styled(StyleSheet({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1 0 30%',
    margin: '0.5rem',
    padding: '0.5rem',
    backgroundColor: '#E8E8EE',
    border: '1px solid black',
    pointerEvents: 'none',
    overflow: 'auto'
  },
  content: {
    marginRight: '0.5rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  thumbnail: {
    maxHeight: '8rem',
    maxWidth: '100%'
  },
  remove: {
    pointerEvents: 'all'
  },
  isDragging: {
    pointerEvents: 'none'
  }
})), _dec(_class = autobind(_class = (_temp = _class2 =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(File, _PureComponent);

  function File() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, File);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(File)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      imageSrc: ''
    });

    return _this;
  }

  _createClass(File, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          file = _this$props.file,
          showImageThumbnail = _this$props.showImageThumbnail;

      if (showImageThumbnail) {
        if (isFileImage(file)) {
          getBase64(file).then(function (res) {
            return _this2.setState({
              imageSrc: res
            });
          });
        }
      }
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(e) {
      var _this$props2 = this.props,
          index = _this$props2.index,
          handleRemove = _this$props2.handleRemove;
      e.stopPropagation();
      e.preventDefault();
      handleRemove(index);
    }
  }, {
    key: "render",
    value: function render() {
      var imageSrc = this.state.imageSrc;
      var _this$props3 = this.props,
          s = _this$props3.styles,
          file = _this$props3.file,
          isDragging = _this$props3.isDragging,
          showImageThumbnail = _this$props3.showImageThumbnail,
          Close = _this$props3.Close;
      return React.createElement("div", s.with('container')(this.props), React.createElement("div", s('content'), showImageThumbnail && isFileImage(file) ? React.createElement("img", _extends({}, s('thumbnail'), {
        src: imageSrc,
        alt: file.name,
        title: file.name
      })) : file.name), React.createElement("div", _extends({}, s('remove', {
        isDragging: isDragging
      }), {
        onClick: this.handleRemove
      }), _.isFunction(Close) ? React.createElement(Close, null) : Close));
    }
  }]);

  return File;
}(PureComponent), _defineProperty(_class2, "displayName", 'File'), _temp)) || _class) || _class);
File.propTypes = process.env.NODE_ENV !== "production" ? {
  index: PropTypes.number,
  isDragging: PropTypes.bool,
  showImageThumbnail: PropTypes.bool,
  handleRemove: PropTypes.func,
  Close: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
} : {};
export default File;